const TEAL   = "#2ABFBF";
const TEAL2  = "#1e9999";
const DARK   = "#111827";
const SILVER = "#9ca3af";
const FONT   = "'DM Sans','Segoe UI',sans-serif";

const FEATURE_TILES = [
  { id:"dashboard", icon:"📊", title:"Financial Dashboard", description:"Revenue analytics, bookings, customer KPIs, and marketing ROI — all in one place.", color:TEAL, available:true },
  { id:"academy",   icon:"🎓", title:"Training Academy",    description:"Staff training videos, assessments, certifications, and progress tracking.", color:"#7c3aed", available:false },
];

export default function PortalPage({ client, onEnterFeature, onLogout }) {
  const enabledFeatures = client.features || ["dashboard"];

  return (
    <div style={{ minHeight:"100vh", background:"#f0fafa", fontFamily:FONT }}>
      {/* Header */}
      <header style={{ background:"#fff", borderBottom:`2px solid ${TEAL}`, padding:"0 32px", height:64, display:"flex", alignItems:"center", justifyContent:"space-between", boxShadow:"0 2px 16px rgba(42,191,191,0.12)" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <img src="/PetKennect3D.jpg" alt="PetKennect"
            style={{ height:42, objectFit:"contain", borderRadius:8, background:"#fff" }}
            onError={e=>{ e.target.style.display="none"; e.target.nextSibling.style.display="block"; }} />
          <div style={{ display:"none", fontSize:18, fontWeight:800, color:TEAL }}>PetKennect</div>
          <div style={{ width:1, height:28, background:"#e5e7eb", margin:"0 4px" }} />
          <div style={{ fontSize:12, color:SILVER, fontWeight:500 }}>Client Portal</div>
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:16 }}>
          <span style={{ fontSize:13, color:"#374151", fontWeight:500 }}>👋 {client.clientName}</span>
          <button onClick={onLogout}
            style={{ background:"transparent", border:"1px solid #e5e7eb", borderRadius:6, padding:"6px 14px", fontSize:12, fontWeight:600, cursor:"pointer", color:"#6b7280", fontFamily:FONT, transition:"all 0.15s" }}
            onMouseEnter={e=>{ e.target.style.borderColor=TEAL; e.target.style.color=TEAL; }}
            onMouseLeave={e=>{ e.target.style.borderColor="#e5e7eb"; e.target.style.color="#6b7280"; }}>
            Sign Out
          </button>
        </div>
      </header>

      {/* Main */}
      <main style={{ maxWidth:900, margin:"0 auto", padding:"52px 24px" }}>
        <div style={{ marginBottom:48 }}>
          <h1 style={{ fontSize:28, fontWeight:800, color:DARK, margin:0, letterSpacing:"-0.02em" }}>
            Welcome back, <span style={{ color:TEAL }}>{client.clientName}</span>
          </h1>
          <p style={{ fontSize:15, color:"#6b7280", margin:"8px 0 0", lineHeight:1.6 }}>Select a service below to get started.</p>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(280px, 1fr))", gap:24 }}>
          {FEATURE_TILES.map(tile => {
            const isEnabled    = enabledFeatures.includes(tile.id);
            const isComingSoon = !tile.available;
            const isLocked     = !isEnabled && !isComingSoon;

            return (
              <div key={tile.id}
                onClick={() => isEnabled && !isComingSoon && onEnterFeature(tile.id)}
                style={{ background:"#fff", borderRadius:16, border:`2px solid ${isEnabled&&!isComingSoon ? tile.color+"33" : "#e5e7eb"}`, padding:28, cursor:isEnabled&&!isComingSoon?"pointer":"default", opacity:isLocked?0.5:1, transition:"all 0.2s", position:"relative", boxShadow:"0 2px 12px rgba(42,191,191,0.07)" }}
                onMouseEnter={e=>{ if(isEnabled&&!isComingSoon){ e.currentTarget.style.transform="translateY(-3px)"; e.currentTarget.style.boxShadow="0 8px 32px rgba(42,191,191,0.18)"; e.currentTarget.style.borderColor=tile.color+"88"; }}}
                onMouseLeave={e=>{ e.currentTarget.style.transform="translateY(0)"; e.currentTarget.style.boxShadow="0 2px 12px rgba(42,191,191,0.07)"; e.currentTarget.style.borderColor=isEnabled&&!isComingSoon?tile.color+"33":"#e5e7eb"; }}>

                {isComingSoon && (
                  <div style={{ position:"absolute", top:16, right:16, background:"#f1f5f9", color:"#64748b", fontSize:10, fontWeight:700, padding:"3px 8px", borderRadius:20, letterSpacing:"0.06em" }}>COMING SOON</div>
                )}
                {isLocked && (
                  <div style={{ position:"absolute", top:16, right:16, background:"#fef3c7", color:"#d97706", fontSize:10, fontWeight:700, padding:"3px 8px", borderRadius:20, letterSpacing:"0.06em" }}>NOT ENABLED</div>
                )}

                <div style={{ width:52, height:52, borderRadius:14, background:isEnabled&&!isComingSoon?tile.color+"18":"#f8fafc", display:"flex", alignItems:"center", justifyContent:"center", fontSize:26, marginBottom:18 }}>
                  {tile.icon}
                </div>
                <div style={{ fontSize:17, fontWeight:700, color:DARK, marginBottom:8 }}>{tile.title}</div>
                <div style={{ fontSize:13, color:"#6b7280", lineHeight:1.6, marginBottom:20 }}>{tile.description}</div>
                {isEnabled && !isComingSoon && (
                  <div style={{ fontSize:13, fontWeight:700, color:tile.color }}>Open →</div>
                )}
              </div>
            );
          })}
        </div>

        <div style={{ marginTop:64, paddingTop:24, borderTop:"1px solid #e5e7eb", textAlign:"center" }}>
          <p style={{ fontSize:12, color:"#9ca3af", margin:0 }}>
            PetKennect Client Portal · Need help?{" "}
            <a href="mailto:devika@petkennect.com" style={{ color:TEAL, textDecoration:"none", fontWeight:600 }}>devika@petkennect.com</a>
          </p>
        </div>
      </main>
    </div>
  );
}
